import { useEffect, useState } from 'react'
import { Text } from '@chakra-ui/react'

type SafeHtmlTextProps = {
  text?: string
  noOfLines?: number
}

const SafeHtmlText = ({ text, noOfLines }: SafeHtmlTextProps) => {
  const [clientText, setClientText] = useState('')

  useEffect(() => {
    setClientText(text || '')
  }, [text])

  if (!clientText) return null

  return <Text {...(noOfLines ? { noOfLines } : {})} fontSize="lg" dangerouslySetInnerHTML={{ __html: clientText }} />
}

export default SafeHtmlText
